import { c as _c } from "react/compiler-runtime";
import { IcoInfo16 } from '@onefootprint/icons';
import { CodeInline, Tooltip } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useEntityVault from '@/entities/hooks/use-entity-vault';
import { getCustomDIs } from '@/entities/utils/get-dis';
import type { WithEntityProps } from '@/entity/components/with-entity';
import type { DiField } from '../../vault.types';
import Field from '../field';
import Fieldset from '../fieldset';
import ShowMoreButton from './components/show-more-button';
import useCustomFieldPlaybookPrompt from './hooks/use-custom-field-playbook-prompt';
type CustomDataFieldsProps = WithEntityProps & {
  title: string;
};
const CustomDataFields = t0 => {
  const $ = _c(16);
  const {
    entity,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const [showAllCta, setShowAllCta] = useState(false);
  const getPrompt = useCustomFieldPlaybookPrompt(entity.id);
  let t2;
  if ($[1] !== entity.data || $[2] !== entity.id) {
    t2 = {
      entityAttributes: entity.data,
      entityId: entity.id
    };
    $[1] = entity.data;
    $[2] = entity.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: vaultWithTransforms
  } = useEntityVault(t2);
  let t3;
  if ($[4] !== entity || $[5] !== getPrompt || $[6] !== showAllCta || $[7] !== t || $[8] !== title || $[9] !== vaultWithTransforms) {
    const {
      vault: vaultData
    } = vaultWithTransforms || {};
    const customDIs = getCustomDIs(vaultData || {}, entity.data);
    const shouldShowShowMore = customDIs.length > 5;
    const initialFields = customDIs.slice(0, 5);
    const additionalFields = customDIs.slice(5);
    let t4;
    if ($[11] !== getPrompt) {
      t4 = field => {
        const prompt = getPrompt(field.di);
        return prompt ? <div className="flex gap-2 items-center"><CodeInline disabled={true}>{field.di}</CodeInline><Tooltip content={prompt}><IcoInfo16 color="tertiary" /></Tooltip></div> : <CodeInline disabled={true}>{field.di}</CodeInline>;
      };
      $[11] = getPrompt;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    const renderLabel = t4;
    let t5;
    if ($[13] !== entity || $[14] !== renderLabel) {
      t5 = field_0 => <Field key={field_0.di} renderLabel={() => renderLabel(field_0)} di={field_0.di} entity={entity} />;
      $[13] = entity;
      $[14] = renderLabel;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    const renderField = t5;
    t3 = vaultData ? <Fieldset fields={customDIs.map(_temp)} title={title}>{initialFields.map(di_0 => renderField({
        di: di_0
      }))}<div className={cx({
        hidden: !showAllCta
      })}>{additionalFields.map(di_1 => renderField({
          di: di_1
        }))}</div>{shouldShowShowMore && <ShowMoreButton showAllCta={showAllCta} onClick={() => setShowAllCta(!showAllCta)} count={`${t(_temp2, {
        count: customDIs.length - 5
      })}`}>{showAllCta ? t(_temp3) : t(_temp4)}</ShowMoreButton>}</Fieldset> : null;
    $[4] = entity;
    $[5] = getPrompt;
    $[6] = showAllCta;
    $[7] = t;
    $[8] = title;
    $[9] = vaultWithTransforms;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default CustomDataFields;
function _temp(di) {
  return {
    di
  };
}
function _temp2($) {
  return $.actions.moreFields;
}
function _temp3($_0) {
  return $_0.actions.showLess;
}
function _temp4($_1) {
  return $_1.actions.showAll;
}